import { useEffect, useState } from 'react';
import { measureKeyboard } from '../lib/keyboard';

/**
 * The numbers behind the keyboard, on the phone itself.
 *
 * A simulated keyboard in a desktop browser cannot tell us what
 * Telegram's WebView actually does with the viewport, and the difference
 * is what cropped the payment sheet. This prints every number the page
 * can see, so a screenshot from a real iPhone settles it.
 *
 * Off unless the app is opened with ?debug=1.
 */
export const wantsDebug = () =>
  new URLSearchParams(window.location.search).get('debug') === '1';

export function KeyboardDebug() {
  const [, tick] = useState(0);
  useEffect(() => {
    const again = () => tick((n) => n + 1);
    const vv = window.visualViewport;
    vv?.addEventListener('resize', again);
    vv?.addEventListener('scroll', again);
    window.addEventListener('resize', again);
    document.addEventListener('focusin', again, true);
    document.addEventListener('focusout', again, true);
    const wa = (window as any).Telegram?.WebApp;
    try { wa?.onEvent?.('viewportChanged', again); } catch { /* older clients */ }
    const timer = setInterval(again, 500);
    return () => {
      vv?.removeEventListener('resize', again);
      vv?.removeEventListener('scroll', again);
      window.removeEventListener('resize', again);
      document.removeEventListener('focusin', again, true);
      document.removeEventListener('focusout', again, true);
      try { wa?.offEvent?.('viewportChanged', again); } catch { /* older clients */ }
      clearInterval(timer);
    };
  }, []);

  const m = measureKeyboard();
  const panel = document.querySelector('.sheet__panel') as HTMLElement | null;
  const box = panel?.getBoundingClientRect();
  const kb = getComputedStyle(document.documentElement).getPropertyValue('--kb').trim() || '—';
  const rows: [string, string | number][] = [
    ['window.innerHeight', m.layout],
    ['visualViewport.h', Math.round(window.visualViewport?.height ?? 0)],
    ['visualViewport.top', m.offsetTop],
    ['tg.viewportHeight', m.tgViewport ?? '—'],
    ['tg.stableHeight', m.tgStable ?? '—'],
    ['measured from', m.source],
    ['keyboard open', m.open ? 'yes' : 'no'],
    ['--kb', kb],
    ['sheet height', box ? Math.round(box.height) : '—'],
    ['sheet top/bottom', box ? `${Math.round(box.top)} / ${Math.round(box.bottom)}` : '—'],
  ];

  return (
    <div style={{
      position: 'fixed', left: 6, top: 6, zIndex: 100000, pointerEvents: 'none',
      background: 'rgba(0,0,0,.82)', color: '#8ef', borderRadius: 8, padding: '6px 8px',
      font: '11px/1.35 ui-monospace, SFMono-Regular, Menlo, monospace', maxWidth: 230,
    }}>
      {rows.map(([k, v]) => (
        <div key={k} style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
          <span style={{ opacity: .7 }}>{k}</span><b>{String(v)}</b>
        </div>
      ))}
    </div>
  );
}
